import VueJwtDecode from 'vue-jwt-decode'

export default {
	// UPDATE_AUTHENTICATED_USER(state, user) {
	// 	localStorage.setItem('userInfo', JSON.stringify(user));
	// 	localStorage.setItem('userRole', 'admin');
	// },
	updateAuthenticatedUser(state, user) {
		localStorage.setItem('userInfo', JSON.stringify(user));
		localStorage.setItem('userRole', 'admin');

		// const _user = JSON.parse(localStorage.user);
		// const _token = VueJwtDecode.decode(_user.token);
		//
		// localStorage.setItem('userRole', _token.role);
	},
	loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
		const _user = JSON.parse(localStorage.user);
		const _token = VueJwtDecode.decode(_user.token);
		// console.log(_token);
		localStorage.setItem('userEmail', _token.email);
		localStorage.setItem('isAdmin', _token.is_admin);
		// localStorage.setItem('userRole', _token.role);
		if(_token.is_admin) {
			localStorage.setItem('userRole', 'admin');
		} else {
			localStorage.setItem('userRole', 'editor');
		}

		localStorage.setItem('tokenExpiry', _token.exp * 1000);
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
}
